import React from 'react';
import styled from 'styled-components';
import PropTypes from 'prop-types';
import { rem } from 'polished';
import { Loader } from 'oxyrion-ui/lib';
import { connect, actions } from '../../Store';
import {
  AnimatedFormMessageWrapper,
  LoaderWrapper,
} from '../../Components/ReusableComponents';

import { __ } from '../../Utils';
import ErrorMessage from '../../Components/ErrorMessage';
import ArticleCard from '../../Components/Article/ArticleCard';
import CampaignCard from '../../Components/CampaignCard';
import API2 from '../../API2';
import SearchMock from '../../Components/MockSearch';

const MainContainer = styled.div`
  padding: ${rem(4)};
  display: flex;

  ${({ theme }) => theme.media.m`
  padding: ${rem(16)};

`};
`;

const InfoBoxesWrapper = styled.div`
  margin-top: ${rem(20)};
  margin-bottom: ${rem(10)};
  display: flex;
  flex-wrap: wrap;
  box-sizing: border-box;
  justify-content: start;
`;

const NewsWrapper = styled(InfoBoxesWrapper)``;

const CampaignsWrapper = styled(InfoBoxesWrapper)``;

const Header = styled.div`
  font-family: 'Open Sans';
  font-weight: 100;
  font-weight: 500;
  font-size: ${rem(30)};
  margin-bottom: ${rem(22)};
`;

const ArticleWrapper = styled.div`
  margin: ${rem(5)};
`;

const NoCampaingsInfo = styled.div`
  color: #d2d2d2;
  font-size: 14px;
`;

const SearchWrapper = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  margin-bottom: ${rem(24)};
  background: #dfe5df;
  padding: 24px;

  .title {
    font-size: 24px;
    margin-bottom: 24px;
    font-weight: bold;
  }
`;

// const PagerWrapper = styled.div`
//   position: relative;
//   bottom: 0;
//   background-color: white;
//   width: 100%;
//   padding: 0;
//   margin-top: ${rem(1)}
//   border-top: ${({ theme }) => `solid ${rem(1)} ${theme.color.disabled}`};
// `;

class News extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      loading: true,
      newsLoading: true,
      error: undefined,
      news: [],
      campaigns: [],
      limit: 100,
      offset: 0,
      // total: 0,
    };

    actions.setActiveMenuItem('1');
  }

  componentDidMount() {
    this.fetchNews();

    this.props.history.push('/news');
  }

  onPageClick(page) {
    const { limit } = this.state;
    this.setState({ offset: (page - 1) * limit, newsLoading: true }, () =>
      this.fetchNews(),
    );
  }

  onDecrease() {
    const { limit, offset } = this.state;
    this.setState({ offset: offset - limit, newsLoading: true }, () =>
      this.fetchNews(),
    );
  }

  onIncrease() {
    const { limit, offset } = this.state;
    this.setState({ offset: offset + limit, newsLoading: true }, () =>
      this.fetchNews(),
    );
  }

  async fetchNews() {
    const { limit, offset } = this.state;

    const params = {
      limit,
      offset,
      lang: this.props.user.appLang,
    };

    try {
      const result = await Promise.all([
        API2.getNewsListAction(params),
        API2.getB2BCustomerCampaignsAction(),
      ]);

      const news = result[0];
      const campaigns = result[1];

      const newsWithPriority = news.items.filter(
        n => n.priority && n.priority > 0,
      );
      const newsWithoutPriority = news.items.filter(
        n => !n.priority || n.priority <= 0,
      );

      newsWithPriority.sort((a, b) => a - b);

      this.setState({
        news: newsWithPriority.concat(newsWithoutPriority) || [],
        campaigns: campaigns.campaigns || [],
        total: news.total,
        newsLoading: false,
        loading: false,
      });
    } catch (e) {
      switch (e.response.status) {
        case 404:
          this.setState({
            error: __('Novinky sa nepodarilo nenačítať.'),
            newsLoading: false,
            loading: false,
          });
          break;
        case 403:
          this.setState({
            error: __('Nemáte potrebné práva.'),
            newsLoading: false,
            loading: false,
          });
          break;
        default:
          this.setState({
            error: __('Pri načítavaní dát sa vyskytla chyba.'),
            newsLoading: false,
            loading: false,
          });
      }
    }
  }

  handleNewsClick(id) {
    this.props.history.push(`/news/${id}`);
  }

  prepareBonusesData() {
    const data = [
      {
        label: __('Pre bonus 1 ešte treba'),
        value: '',
      },
      {
        label: __('Pre bonus 2 ešte treba'),
        value: '',
      },
    ];

    return data;
  }

  render() {
    const {
      loading,
      error,
      news,
      // limit,
      // offset,
      // total,
      campaigns,
      newsLoading,
    } = this.state;

    const { userRole } = this.props;

    return (
      <MainContainer>
        <ErrorMessage display={error} text={error} />

        {loading && (
          <LoaderWrapper style={{ width: '100%' }}>
            <Loader size="xl" />
          </LoaderWrapper>
        )}
        <AnimatedFormMessageWrapper display={!loading}>
          {userRole && userRole.sections_permisions.includes('news') && (
            <React.Fragment>
              <SearchWrapper>
                <div className="title">{__('Vyhľadajte produkt')}</div>
                <SearchMock
                  onHitClick={id =>
                    this.props.history.push(`/catalog/list/${id}`)
                  }
                  onSubmit={q => this.props.history.push(`/buy/catalog?q=${q}`)}
                />
              </SearchWrapper>
              <Header>{__('Novinky')}</Header>
              <NewsWrapper>
                {newsLoading && (
                  <LoaderWrapper style={{ width: '100%' }}>
                    <Loader size="xl" />
                  </LoaderWrapper>
                )}
                {!newsLoading &&
                  news.map(n => {
                    return (
                      <ArticleWrapper
                        onClick={() => {
                          this.handleNewsClick(n._id);
                        }}
                      >
                        <ArticleCard
                          color={n.color}
                          name={n.name}
                          perex={n.perex}
                          thumbnail={n.thumbnail}
                          video_label={n.video_label}
                          appLang={this.props.appLang}
                        />
                      </ArticleWrapper>
                    );
                  })}
              </NewsWrapper>
            </React.Fragment>
          )}
          {userRole && userRole.sections_permisions.includes('campaings') && (
            <React.Fragment>
              <Header>{__('Prebiehajúce kampane')}</Header>
              {campaigns && campaigns.length ? (
                <CampaignsWrapper>
                  {campaigns.map(c => (
                    <CampaignCard data={c} />
                  ))}
                </CampaignsWrapper>
              ) : (
                <NoCampaingsInfo>
                  {__('Momentálne neprebiehajú žiadne kampane')}
                </NoCampaingsInfo>
              )}
            </React.Fragment>
          )}
        </AnimatedFormMessageWrapper>
      </MainContainer>
    );
  }
}

News.propTypes = {
  user: PropTypes.shape({
    name: PropTypes.string,
    surname: PropTypes.string,
    email: PropTypes.string,
    phone: PropTypes.string,
    role: PropTypes.string,
  }),
};

News.defaultProps = {
  user: {
    name: '',
    surname: '',
    email: '',
    phone: '',
    role: '',
  },
};

const mapStateToProps = state => {
  return {
    ...state,
  };
};

export default connect(mapStateToProps)(News);



// WEBPACK FOOTER //
// ./src/Containers/News/index.jsx